module.exports = __webpack_public_path__ + "img/zhifuwancheng.5732b913.png";